// src/apiPath.js
const API_PATH = "https://app.dattainfra.com"; //domain change
// const API_PATH = "http://192.168.0.109:4400";
//const API_PATH = "http://localhost:50000";

export default API_PATH;
